import type { JSX } from 'react';
import { Newspaper } from 'lucide-react';

/**
 * "Page" marker for theme / news / meme / clip pages, with the reasons on
 * hover. Renders nothing for people or when the check never ran.
 */
export function PageTag({ enrichment }: { enrichment: Record<string, unknown> | null | undefined }): JSX.Element | null {
  if (!enrichment || enrichment.pageKind !== 'page') return null;
  const signals = Array.isArray(enrichment.pageSignals) ? (enrichment.pageSignals as string[]) : [];
  return (
    <span
      className="inline-flex items-center gap-1 rounded-md border border-violet-600/30 bg-violet-600/10 px-1.5 py-0.5 text-xs font-medium leading-none text-violet-800 dark:text-violet-300"
      title={`Reads as a page, not a person${signals.length ? `:\n${signals.join('\n')}` : ''}`}
    >
      <Newspaper className="h-3 w-3" strokeWidth={2} />
      Page
    </span>
  );
}
